import { render, staticRenderFns } from "./Fonn.vue?vue&type=template&id=57d87800"
import script from "./Fonn.vue?vue&type=script&lang=js"
export * from "./Fonn.vue?vue&type=script&lang=js"
import style0 from "./Fonn.vue?vue&type=style&index=0&id=57d87800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports